import { getOptionParamValue } from "./chartAddon"
import _ from "lodash"

interface Window {
  Logic: any
  IntelliFactory: any
  Trading: any
}

declare var window: Window

export const removeSubChart = (type: string, _controller: any) => {
  if (type === "SinyouZan") type = "信用残"
  if (type === "Volume") type = "VolumeMa3"
  if (type === "Spread") {
    _controller.RemoveMDNIndicator.call(null, spreadPropety.spread)
    spreadPropety.setSpread(null)
    return
  }
  _controller.RemoveIndicator.call(null, type)
}

export const setSubChart = (
  chartSetting: object,
  type: string,
  _controller: any,
  term: string = null,
  keys: Array<string | null> = [],
  upDate = false
) => {
  if (!_controller) return
  const viewType = _controller.Chart.get_Chart().get_View()
  if (!(viewType instanceof window.Trading.Chart.TSView)) return
  const _getOptionParamValue = getOptionParamValue(chartSetting, "sub", term)
  let paraList = window.Logic.Helper.emptyList()
  let dispList = window.Logic.Helper.emptyList()
  let scaleList = window.Logic.Helper.emptyList()
  switch (type) {
    case "RSI":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "Kikan",
          _getOptionParamValue("RSI", "RSI_Period", 14)
        ),
      ])
      scaleList = window.IntelliFactory.WebSharper.List.ofArray(
        _getScaleLineParamValue(
          "RSI",
          ["RSI_Scale1", "RSI_Scale2", "RSI_Scale3"],
          keys,
          [20, 50, 80],
          _getOptionParamValue
        )
      )
      break
    case "StocastKD":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "KKikan",
          _getOptionParamValue("StocastKD", "Stocast_K", 9)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "DKikan",
          _getOptionParamValue("StocastKD", "Stocast_D", 3)
        ),
      ])
      dispList = window.IntelliFactory.WebSharper.List.ofArray([
        ["PercentK", Number(_.includes(keys, "Stocast_K"))],
        ["PercentD", Number(_.includes(keys, "Stocast_D"))],
      ])
      scaleList = window.IntelliFactory.WebSharper.List.ofArray(
        _getScaleLineParamValue(
          "StocastKD",
          ["Stocast_Scale1", "Stocast_Scale2", "Stocast_Scale3"],
          keys,
          [30, 70, 50],
          _getOptionParamValue
        )
      )
      break
    case "StocastDS":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "KKikan",
          _getOptionParamValue("StocastDS", "Stocast_DS_K", 9)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "DKikan",
          _getOptionParamValue("StocastDS", "Stocast_DS_D", 3)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "SDKikan",
          _getOptionParamValue("StocastDS", "Stocast_DS_S", 3)
        ),
      ])
      dispList = window.IntelliFactory.WebSharper.List.ofArray([
        ["PercentD", Number(_.includes(keys, "Stocast_DS_D"))],
        ["SPercentD", Number(_.includes(keys, "Stocast_DS_S"))],
      ])
      scaleList = window.IntelliFactory.WebSharper.List.ofArray(
        _getScaleLineParamValue(
          "StocastDS",
          ["Stocast_Scale1", "Stocast_Scale2", "Stocast_Scale3"],
          keys,
          [30, 70, 50],
          _getOptionParamValue
        )
      )
      break
    case "PercentR":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "Kikan",
          _getOptionParamValue("PercentR", "PercentR_Period", 14)
        ),
      ])
      break
    // break;

    case "MACD":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "MacdShort",
          _getOptionParamValue("MACD", "MACD_S", 5)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "MacdLong",
          _getOptionParamValue("MACD", "MACD_L", 20)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "SignalKikan",
          _getOptionParamValue("MACD", "MACD_signal", 9)
        ),
      ])
      dispList = window.IntelliFactory.WebSharper.List.ofArray([
        ["MACD", Number(_.includes(keys, "MACD_S"))],
        ["Signal", Number(_.includes(keys, "MACD_signal"))],
        ["OSCI", Number(_.includes(keys, "MACD_Osci"))],
      ])
      scaleList = window.IntelliFactory.WebSharper.List.ofArray([0])
      break
    case "RCI3":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "Kikan1",
          _getOptionParamValue("RCI3", "RCI_Period1", 9)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "Kikan2",
          _getOptionParamValue("RCI3", "RCI_Period2", 12)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "Kikan3",
          _getOptionParamValue("RCI3", "RCI_Period3", 24)
        ),
      ])
      dispList = window.IntelliFactory.WebSharper.List.ofArray([
        ["RCI1", Number(_.includes(keys, "RCI_Period1"))],
        ["RCI2", Number(_.includes(keys, "RCI_Period2"))],
        ["RCI3", Number(_.includes(keys, "RCI_Period3"))],
      ])
      scaleList = window.IntelliFactory.WebSharper.List.ofArray(
        _getScaleLineParamValue(
          "RCI3",
          ["RCI_Scale1", "RCI_Scale2", "RCI_Scale3"],
          keys,
          [0, 70, -70],
          _getOptionParamValue
        )
      )
      break

    case "CCI":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "Kikan",
          _getOptionParamValue("CCI", "CCI_Period", 15)
        ),
      ])
      break

    case "PsyCologic":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "Kikan",
          _getOptionParamValue("PsyCologic", "PsyCologic_Period", 12)
        ),
      ])
      scaleList = window.IntelliFactory.WebSharper.List.ofArray(
        _getScaleLineParamValue(
          "PsyCologic",
          ["PsyCologic_Scale1", "PsyCologic_Scale2", "PsyCologic_Scale3"],
          keys,
          [25, 75, 50],
          _getOptionParamValue
        )
      )
      break
    case "ROC2":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "Kikan1",
          _getOptionParamValue("ROC2", "ROC_Period1", 5)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "Kikan2",
          _getOptionParamValue("ROC2", "ROC_Period2", 20)
        ),
      ])
      dispList = window.IntelliFactory.WebSharper.List.ofArray([
        ["ROC1", Number(_.includes(keys, "ROC_Period1"))],
        ["ROC2", Number(_.includes(keys, "ROC_Period2"))],
      ])
      break

    case "ATR":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "Kikan",
          _getOptionParamValue("ATR", "ATR_Period", 10)
        ),
      ])
      break
    case "MomentumS":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "Kikan",
          _getOptionParamValue("MomentumS", "Momentum_Period1", 25)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "SKikan",
          _getOptionParamValue("MomentumS", "Momentum_SKikan", 10)
        ),
      ])
      //   TODO
      dispList = window.IntelliFactory.WebSharper.List.ofArray([
        [
          "Momentum",
          _getOptionParamValue("MomentumS", "Momentum_Period1_Vis", true),
        ],
        [
          "Signal",
          _getOptionParamValue("MomentumS", "Momentum_SignalVis", true),
        ],
      ])
      break
    case "DMImod":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "DMIKikan",
          _getOptionParamValue("DMImod", "DMI_dmi", 14)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "ADXModifier",
          Number(_.includes(keys, "ADXModifier"))
        ), // 0:今まで(単純移動平均)の計算、1:修正ADX計算(平滑移動平均)
        window.Trading.Chart.Proto.Controller.intParam(
          "ADX1Kikan",
          _getOptionParamValue("DMImod", "DMI_Adx1", 9)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "ADXR1Kikan",
          _getOptionParamValue("DMImod", "DMI_Adxr1", 12)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "ADX2Kikan",
          _getOptionParamValue("DMImod", "DMI_Adx2", 10)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "ADXR2Kikan",
          _getOptionParamValue("DMImod", "DMI_Adxr2", 14)
        ),
      ])
      dispList = window.IntelliFactory.WebSharper.List.ofArray([
        ["+DI", Number(_.includes(keys, "+DI"))],
        ["-DI", Number(_.includes(keys, "-DI"))],
        ["ADX1", Number(_.includes(keys, "DMI_Adx1"))],
        ["ADXR1", Number(_.includes(keys, "DMI_Adxr1"))],
        ["ADX2", Number(_.includes(keys, "DMI_Adx2"))],
        ["ADXR2", Number(_.includes(keys, "DMI_Adxr2"))],
      ])
      break

    case "AroonIndi":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "UpKikan",
          _getOptionParamValue("AroonIndi", "AroonIndi_UpPeriod", 10)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "DownKikan",
          _getOptionParamValue("AroonIndi", "AroonIndi_DownPeriod", 10)
        ),
      ])
      break

    case "AroonOsci":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "UpKikan",
          _getOptionParamValue("AroonOsci", "AroonOsci_UpPeriod", 10)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "DownKikan",
          _getOptionParamValue("AroonOsci", "AroonOsci_DownPeriod", 10)
        ),
      ])
      break

    case "Kairi3":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "Short",
          _getOptionParamValue("Kairi3", "Kairi3_1", 6)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "Middle",
          _getOptionParamValue("Kairi3", "Kairi3_2", 12)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "Long",
          _getOptionParamValue("Kairi3", "Kairi3_3", 24)
        ),
      ])
      dispList = window.IntelliFactory.WebSharper.List.ofArray([
        ["Short", Number(_.includes(keys, "Kairi3_1"))],
        ["Middle", Number(_.includes(keys, "Kairi3_2"))],
        ["Long", Number(_.includes(keys, "Kairi3_3"))],
      ])
      scaleList = window.IntelliFactory.WebSharper.List.ofArray(
        _getScaleLineParamValue(
          "Kairi3",
          ["Kairi3_Scale1", "Kairi3_Scale2", "Kairi3_Scale3"],
          keys,
          [0, 70, -70],
          _getOptionParamValue
        )
      )
      break

    case "Volume":
    case "VolumeMa3":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "Short",
          _getOptionParamValue("Volume", "Volume_Short", 6)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "Middle",
          _getOptionParamValue("Volume", "Volume_Middle", 12)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "Long",
          _getOptionParamValue("Volume", "Volume_Long", 24)
        ),
      ])
      dispList = window.IntelliFactory.WebSharper.List.ofArray([
        ["Short", Number(_.includes(keys, "Volume_Short"))],
        ["Middle", Number(_.includes(keys, "Volume_Middle"))],
        ["Long", Number(_.includes(keys, "Volume_Long"))],
      ])
      type = "VolumeMa3"
      break

    // 標準偏差ボラティリティ
    case "StandardDeviation":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "Kikan",
          _getOptionParamValue(
            "StandardDeviation",
            "STANDARD_DEVIATION_Period",
            26
          )
        ),
      ])
      break

    // 強弱レシオ
    case "HinoharaRatio":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "Kikan",
          _getOptionParamValue("HinoharaRatio", "HinoharaRatio_Period", 10)
        ),
      ])
      dispList = window.IntelliFactory.WebSharper.List.ofArray([
        ["RatioA", Number(_.includes(keys, "HinoharaRatio_RatioA"))],
        ["RatioB", Number(_.includes(keys, "HinoharaRatio_RatioB"))],
      ])
      break

    case "SinyouZan":
    case "信用残":
      dispList = window.IntelliFactory.WebSharper.List.ofArray([
        ["MarginBuying", Number(_.includes(keys, "MarginBuying"))],
        ["MarginSelling", Number(_.includes(keys, "MarginSelling"))],
      ])
      type = "信用残" // F#側では信用残で定義しているJavascipt側ではASCII文字でワーニングがでるので、SinyouZanで定義している
      break
    default:
      break
    case "Spread":
      return addSpread(_controller)
  }

  try {
    _controller.AddIndicator.call(null, [type, paraList, dispList, scaleList])
  } catch {
    _controller.UpdateIndicatorParam.call(null, [
      type,
      paraList,
      dispList,
      scaleList,
    ])
  }
}

const _getScaleLineParamValue = (
  group: string,
  targets: Array<string>,
  keys: Array<string>,
  defaultValue: Array<number>,
  fn: Function
) => {
  let res: Array<number> = []
  _.forEach(keys, (key, index) => {
    if (_.includes(targets, key)) res.push(fn(group, key, defaultValue[index]))
  })
  return res
}

const addSpread = (_controller: any) => {
  if (spreadPropety.spread)
    _controller.RemoveMDNIndicator.call(null, spreadPropety.spread)
  const _data = _controller.AddMDNIndicator.call(null, [
    "Diff",
    window.Logic.Helper.emptyList(),
    window.Logic.Helper.emptyList(),
    window.IntelliFactory.WebSharper.List.ofArray([0]),
    {
      $: 0,
    },
  ])
  spreadPropety.setSpread(_data)
}

const spreadPropety: { spread: any; setSpread: Function } = {
  spread: null,
  setSpread: (spread: any) => {
    spreadPropety.spread = spread
  },
}
